// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Licence resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class LicenceClient {
  constructor(private readonly http: HttpClient) {}

  /** Apply a signed licence file to the running deployment (owner only). Proxies to the licensing service. */
  async uploadLicence(request: { licenceJson: string; signature: string }, requestOptions?: RequestOptions): Promise<{ state: string; expiresAt: string }> {
    return this.http.post<{ state: string; expiresAt: string }>('/v1/licence/upload', request, requestOptions);
  }

  /** Dry-run validate a signed licence file without applying it (owner only). Proxies to the licensing service. */
  async validateLicence(request: { licenceJson: string; signature: string }, requestOptions?: RequestOptions): Promise<{ valid: boolean; reason: string; wouldExpire: string; wouldState: string }> {
    return this.http.post<{ valid: boolean; reason: string; wouldExpire: string; wouldState: string }>('/v1/licence/validate', request, requestOptions);
  }
}
